import httpManager from "@/app/shared/utils/httpManager";

class PlanConfigServices {

  async getDataPlanClientById(id: number) {
    const url = `/customers/plan-config/${id}/`;
    const response = await httpManager.get(url);

    return response.data;
  }

  async getDataPlanConfig(token: string) {
    const url = `/customers/plan-config/upgrade-downgrade/${token}/`;
    const response = await httpManager.get(url, { isPublic: true });
    
    return response.data;
  }

  async approveUpgradeDowngrade(idPlan: number, data: any) {
    const url = `/customers/plan-config/${idPlan}/approve/`;
    const response = await httpManager.put(url, data, { isPublic: true });

    return response.data;
  }

  async getDataPlanConfigById(id: string) {
    const url = `/customers/plan-config/upgrade-downgrade/${id}/`;
    const response = await httpManager.get(url, { isPublic: true });

    return response.data;
  }

  async applyPlanConfig(id: number, data: any) {
    const url = `/customers/plan-config/${id}/upgrade-downgrade/apply/`;
    const response = await httpManager.put(url, data);

    return response.data;
  }

}

export const planConfigServices = new PlanConfigServices();
